<template>
  <transition name="modal">
    <div v-if="showModal" class="alarm-popup">
      <div class="wrap">
        <div class="modal-mask">
          <section class="modal-wrapper">
            <h1 class="popup-title" tabindex="1">알림함 팝업</h1>
            <button class="popup-close ir" @click.prevent="close">
              팝업 닫기
            </button>
            <div class="alarm-modal-container">
              <slot name="popup-body"></slot>
            </div>
          </section>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    props: {
      showModal: {
        type: Boolean,
      },
    },
    methods: {
      close() {
        this.$emit('close')
      },
    },
  }
</script>

<style lang="scss">
  /* 팝업 */
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }

  .modal-wrapper {
    margin: 100px auto 0;
    position: relative;
  }

  .alarm-modal-container {
    width: 100%;
    border-radius: 8px;
    transition: all 0.3s ease;
    overflow: hidden;
  }

  /*!* 팝업 - 닫기 *!*/
  .popup-close {
    position: absolute;
    right: -36px;
    top: 0;
  }

  /*알림 팝업*/
  .alarm-popup .modal-wrapper {
    width: 560px;
    text-align: center;
  }

  .my-pop-alert {
    width: 100%;
    background-color: #252525;
  }

  .my-pop-alert-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 86px;
    padding: 0 35px;
    background-color: #1351f9;
    line-height: 86px;
    text-align: left;
  }

  .my-pop-alert-top > span {
    font-weight: 700;
    font-size: 24px;
    color: #fff;
  }

  .my-pop-alert-top-button-container {
    display: flex;
    align-items: center;
  }

  .my-pop-alert-top-btn {
    display: flex;
    align-items: center;
    text-align: center;
    padding: 0 24px;
    margin-left: 10px;
    height: 40px;
    line-height: 38px;
    color: #fff;
    font-size: 0;
    letter-spacing: -0.2px;
    border: 1px solid #fff;
    border-radius: 100px;
  }

  .my-pop-alert-top-btn > span {
    font-size: 14px;
    vertical-align: middle;
    margin-left: 4px;
  }
  .delete-my-alert {
    padding: 10px 27px 10px 0;
    font-size: 0;
    text-align: right;
  }

  .delete-my-alert button {
    font-size: 12px;
    line-height: 34px;
    color: #666;
  }

  .delete-my-alert button:first-child {
    color: #a5a5a5;
    padding-right: 8px;
  }

  .pop-alert-wrap-pb {
    padding-bottom: 30px;
  }

  .pop-alert-wrap {
    padding: 0 27px 40px 35px;
    background: url(../../assets/images/mypooq/alert-bg.png) repeat-y 56px;
    &:last-child {
      padding-bottom: 0;
    }
  }

  .pop-alert-date {
    text-align: left;
    color: #fff;
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 10px;
  }

  .ic-clock {
    display: inline-block;
    position: relative;
    width: 40px;
    height: 40px;
    background-color: #2f2f2f;
    border: solid 1px #2f2f2f;
    border-radius: 50%;
    margin: 0 9px 0 3px;
    text-align: center;
    line-height: 36px;
    vertical-align: middle;
  }

  .ic-clock > span {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .pop-alert-list > li {
    margin: 0 0 15px 16px;
    position: relative;
    width: 100%;
  }

  .pop-alert-list > li:last-child {
    margin-bottom: 0;
  }

  .pop-alert-list > li:before {
    position: absolute;
    left: 1px;
    top: 50%;
    content: '';
    display: inline-block;
    width: 9px;
    height: 9px;
    margin-top: -5px;
    background-color: #2f2f2f;
    border-radius: 5px;
  }

  .pop-alert-con {
    display: inline-block;
    width: calc(100% - 24px);
    text-align: left;
    vertical-align: middle;
    float: left;
  }

  .pop-list-wrap {
    display: inline-block;
    border: solid 1px #2f2f2f;
    border-radius: 6px;
    padding: 20px 20px 20px 25px;
    width: calc(100% - 44px);
    vertical-align: middle;
    margin-left: 16px;
  }

  .pop-arrow-bg {
    border-top: 8px solid #2f2f2f;
    border-right: 6px solid transparent;
    border-left: 6px solid transparent;
    position: absolute;
    top: 50%;
    margin-top: -4px;
    left: 21px;
    -ms-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }

  .pop-arrow-line {
    border-top: 8px solid #2f2f2f;
    border-right: 6px solid transparent;
    border-left: 6px solid transparent;
    position: absolute;
    top: 50%;
    margin-top: -4px;
    left: 20px;
    -ms-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }

  .pop-arrow-gray {
    border-top: 8px solid #f8f8f8;
    border-right: 6px solid transparent;
    border-left: 6px solid transparent;
    position: absolute;
    top: 50%;
    margin-top: -4px;
    left: 20px;
    -ms-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }

  .pop-alert-delete {
    width: 34px;
    height: 34px;
    position: absolute;
    top: 50%;
    right: 25px;
    margin-top: -17px;
    color: currentColor;
  }

  .pop-alert-con-tit {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 16px;
    line-height: 22px;
    color: #a5a5a5;
    word-wrap: break-word;
    white-space: normal;
    overflow: hidden;
    max-height: 44px;
    width: calc(100% - 25px);
  }

  .pop-alert-con-date {
    display: block;
    font-size: 14px;
    margin-top: 4px;
    color: #a5a5a5;
  }

  .pop-con-back {
    background: #f8f8f8;
    border: 1px solid #f8f8f8;
  }

  /* 알림 없음 팝업 */
  .my-pop-alert-empty {
    padding-top: 130px;
    text-align: center;
    font-size: 22px;
    color: #a5a5a5;
    height: 464px;
  }

  .my-pop-alert-empty > p {
    margin-top: 13px;
  }

  /*알림 설정*/
  .my-pop-setting-list {
    padding: 10px 35px;
  }

  .my-pop-setting-list li {
    padding: 22px 0;
  }

  .my-pop-setting-list li:after {
    content: '';
    display: block;
    clear: both;
  }

  .alert-setting-tit {
    float: left;
    font-weight: 700;
    font-size: 16px;
    color: #a5a5a5;
  }

  .my-pop-setting-list .radio-style {
    float: right;
  }

  .my-pop-setting-list .radio-style input[type='radio'] + label {
    font-size: 16px;
  }

  .popup-scroll {
    overflow-y: scroll;
    height: 682px;
    position: relative;
  }

  .my-pop-alert-body .popup-scroll {
    margin-right: 8px;
  }
</style>
